import React from "react";
import "./Impressum.css";

export default function Impressum() {
  return (
    <main className="impressum-container">
      <h1>Impressum</h1>

      <p>
        <strong>Angaben gemäß § 5 TMG</strong>
      </p>
      <p>
        STG Diver Duck Berlin e.V.<br></br>
        c/o Hans-Joachim Weidner<br></br>
        Seestr. 98,
        <br />
        15738 Zeuthen
      </p>

      <p>
        <strong>Vertreten durch:</strong>
        <br />
        1. Vorsitzender: Hans-Joachim Weidner
        <br />
        2. Vorsitzende: Marita Storim
      </p>

      <p>
        <strong>Kontakt:</strong>
        <br />
        E-Mail: <a href="mailto:diver.duck@web.de">diver.duck@web.de</a>
      </p>

      <p>
        <strong>Registereintrag:</strong>
        <br />
        Vereinsregister-Nr.95VR70D2Nz beim Amtsgericht Charlottenburg <br />
        VDST-Vereins-Nr. 03/4090 LSB-Mitglieds-Nr. 4424
      </p>

      <p>
        <strong>Haftungsausschluss:</strong>
        <br />
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
        für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
        sind ausschließlich deren Betreiber verantwortlich.
      </p>
    </main>
  );
}
